import { forkJoin } from "rxjs";
import { ID } from "@vendure/core/dist";
import { take } from "rxjs/operators";
import {
  BulkAction,
  DataService,
  NotificationService,
  ModalService,
} from "@bb-vendure/admin-ui/core";
import { RemoveFanClubLinkDocument } from "src/generated-gql/graphql";

export const bulkRemoveLinks: BulkAction = {
  label: "Remove Links",
  icon: "trash",
  iconClass: "is-danger",
  location: "link-page",
  onClick: ({ hostComponent, clearSelection, injector, selection }) => {
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    const modalService = injector.get(ModalService);

    modalService
      .dialog({
        title: "Remove Links",
        body: `Are you sure you want to remove ${selection.length} links?`,
        buttons: [
          { label: "Cancel", type: "secondary" },
          { label: "Remove", type: "danger", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const mutations = selection.map((link) =>
            dataService
              .mutate(RemoveFanClubLinkDocument, { id: link.id })
              .pipe(take(1))
          );

          forkJoin(mutations).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
            notificationService.success(
              `Removed ${selection.length} links successfully`
            );
          });
        }
      });
  },
};
